/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2024-04-30 16:26:29
 * @LastEditors: kevinqq 350910378@qq.com
 * @LastEditTime: 2025-02-24 19:55:09
 * @FilePath: \baishu_react_ui\src\components\BsyFlowLog\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useEffect, useRef, useState } from "react";
import { BsyUtils } from "../../utils/Utils";

import "./index.css";
import { BsyWidget } from "../BsyWidget";
import classNames from "classnames";
import BsyUserAvatarThumbList from "../BsyUserAvatarThumbList";
import BsyAlertMenu from "../BsyAlertMenu";
import BsyMaskLayer from "../BsyMaskLayer";
import BsyFormPane from "../BsyFormPane";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsyAlert from "../BsyAlert";
import BsySLoading from "../BsySLoading";
import { dayjsUtils } from "../../utils/dayjsUtils";

export const FlowLogShowCharge = function (props) {
  const { charges } = props;

  const ref = useRef(null);
  const [showUser, setShowUser] = useState([]);
  const [popupItem, setPopupItem] = useState([]);
  const [showUserIndex, setShowUserIndex] = useState(1);

  useEffect(() => {
    const lineHeight = ref.current
      ? parseInt(window.getComputedStyle(ref.current).lineHeight, 10)
      : 0;

    if (showUserIndex <= (charges?.length || 0)) {
      if (lineHeight * 3 > (ref.current?.offsetHeight || 0)) {
        const node = (charges || [])?.slice(0, showUserIndex);

        if (node.length) {
          setShowUser(node);
          setShowUserIndex(showUserIndex + 1);
        }
      } else {
        setShowUser(showUser.slice(0, showUser.length - 1));
        setPopupItem(
          (charges || [])?.slice(showUser.length - 1, charges?.length || 0)
        );
        // setShowUserIndex(showUserIndex + 1);
      }
    }
  }, [showUserIndex]);
  const mareC = (charges?.length || 0) - showUser.length;
  return (
    <div className="todo-user" ref={ref}>
      {showUser.map((it) => {
        return <BsyUserAvatarThumbList mode="avatar" list={[it]} />;
      })}
      {mareC ? (
        <div
          className="more-number"
          onClick={(event) => {
            const menu = popupItem.map((it) => {
              return {
                text: it.nickname,
                click: () => { },
              };
            });

            BsyAlertMenu({
              item: menu,
              width: 220,
              target: event.target,
              onClose: () => { },
            });
          }}
        >
          +{mareC}
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default class BsyFlowLog extends BsyWidget {
  constructor(props) {
    super({
      baseCls: "bsy-flow-log",
      appId: null,
      entryId: null,
      formId: null,
      flowId: null,
      flowType: null,
      data: null,
      ...props,
    });
    this.state = {
      allTimeLong: "",
      loglist: [],
      subFlowMoreState: {},
      ...props,
    };
  }

  renderAllTime = () => {
    const { allTimeLong, data } = this.state;
    return allTimeLong ? (
      <div className="flow-log-all-time">
        <span>{React.language("flow.total.time")}</span>
        <span className="time">{allTimeLong}</span> <span>，</span>{" "}
        <span>
          {React.language(
            Number(data.flowState) === 0
              ? "flow.state.inProcess"
              : "flow.node.end"
          )}
        </span>
      </div>
    ) : (
      ""
    );
  };

  getCode2Str = (err_code) => {
    switch (err_code) {
      case "back_no_charger": {
        return React.language("flow.charge.fail.noBackCharger");
        break;
      }
      case "forward_no_charger": {
        return React.language("flow.charge.fail.noNextCharger");
        break;
      }
      case "forward_charger_number": {
        return React.language("flow.charge.fail.forwardChargerNumber");
        break;
      }
      case "charger_spare": {
        return React.language("form.chargersEmptyRule.spareChargers.log");
        break;
      }
      case "forward_condition_fail": {
        return React.language("flow.charge.fail.noCondition");
        break;
      }
      case "no_batch_forward": {
        return React.language("error.5023");
        break;
      }
      default:
        return "";
    }
  };

  openSubFlow = (it) => {
    let that = this;
    let opt = this.options;


    if ("delete" === it.state) {
      tipAlert({
        type: "warning",
        msg: React.language("form.sub.data.deleted")
      });
      return
    }

    let layerRefLoading = null;
    BsyMaskLayer({
      customCls: "sloading",
      onContentCreate: (ref) => {
        layerRefLoading = ref;
        return (
          <div>
            <BsySLoading />
          </div>
        );
      },
    });

    const { restore } = BsyUtils.globalIdManager(opt.appId, opt.entryId);
    var d1 = BsyUtils.checkRefApp({
      appId: it.appId,
      entryId: it.entryId || it.formId,
      formId: it.entryId || it.formId,
      dataId: it.dataId,
      popupFormPath: (opt.popupFormPath || []).concat({
        formId: opt.formId || opt.entryId,
        appId: opt.refAppId || opt.appId,
        entryId: opt.formId || opt.entryId,
        flowId: opt.flowId,
        flowType: opt.flowType,
        dataId: opt.data._id,
        widgetName: "subflow"
      }),
    });
    let layerRef = null;
    React.axios(opt.ignoreOptAuth ? "/data/dataShow" : "/data/dataView", d1).then((res) => {
      layerRefLoading && layerRefLoading.close();
      const { data: g } = res;
      let fieldtabs = {};
      BsyUtils.forEach(g.form.items, function (a1, b1) {
        if (b1.tab) fieldtabs[b1.widget.widgetName] = b1.tab;
      });
      let newdata = {};
      let fields = g.fields;

      newdata = { ...g.data };
      let config = {
        ...g.form,
        appId: d1.appId,
        refAppId: g.refAppId,
        entryId: d1.entryId,
        formId: d1.formId,
        items: g.form.items,
        form: g.form,
        entrance: "form",
        fieldShowRules: that.props.ignoreAuth ? [] : g.form.fieldShowRules,
        subformFieldShowRules: that.props.ignoreAuth
          ? []
          : g.form.subformFieldShowRules,
        authGroupId: null,
        optAuth: g.optAuth,
        is_dock_form: g.is_dock_form,
        hasShareBtn: !1,
        width: "80%",
        forms: that.state.forms,
        header: fields,
        allShowFields: fields,
        data: newdata,
        editValue: newdata,
        multiTabs: g.formTabs,
        formTabsStyle: g.formTabsStyle || {},
        dataId: g.data._id,
        rawdata: that.props.rawdata,
        title: that.props.title,
        height: "100%",
        hasSwitchBtn: !0,
        hasPrintBtn: !0,
        hasCustomPrint: !0,
        hasEditBtn: g.hasEditBtn,
        hasDeleteBtn: g.hasDeleteBtn,
        hasLog: g.hasLog,
        hasComment: g.hasComment,
        hasFlowLog: !g.hasCoop && g.hasFlow && g.flow_log,
        hasLogView: g.hasLogView,
        hasFlowBtn: g.hasFlow && !g.hasRecoverBtn,
        flow_activate: g.hasFlow && g.flow_activate,
        popupFormPath: (opt.popupFormPath || []).concat({
          formId: opt.formId || opt.entryId,
          appId: opt.refAppId || opt.appId,
          entryId: opt.formId || opt.entryId,
          flowId: opt.flowId,
          flowType: opt.flowType,
          dataId: opt.data._id,
          widgetName: "subflow"
        }),
      };
      const configEvents = {

        onClose: function (isEdit, reshow) {
          // if (isEdit) {
          //   that.reload({});
          // }

          restore();
          layerRef.close();
        },
        onCloseFlow: function () { },
        onDeleteData: function () {
          BsyAlert({
            // title: React.language("api.deleteData"),
            title: React.language("del.data.tip"),
            type: "error",
            text4Cancel: React.language("cancel"),
            text4Ok: React.language("ok"),
            OkType: "red",
            ok: function () {
              // that.BBY_doDeleteData([f]);
              restore();
              layerRef.close();
            },
          });
        },
      };

      const formConfig = {
        ...g,
        appId: it.appId,
        entryId: it.formId || it.entryId,
        formId: it.formId || it.entryId,
        dataId: it.dataId,
        content: config,
      };

      BsyMaskLayer({
        customCls: "fadein-right",
        onMaskClick: (event) => {
          // if (event.target.classList.contains("BsyMaskLayer")) {
          //   layerRef.close();
          // }
        },
        onContentCreate: (ref) => {
          layerRef = ref;

          return (
            <BsyFormPane
              {...config}
              {...configEvents}
              formConfig={formConfig}
              mode={"view"}
            />
          );
        },
      });
    }).catch((err) => {
      console.log(err);
      layerRefLoading && layerRefLoading.close();
    })

    // window.FX.Utils.dataAjax(
    //   {
    //     url: opt.ignoreOptAuth ? "/data/dataShow" : "/data/dataView",
    //     data: d1,
    //   },
    //   function (g) {
    //     let fieldtabs = {};
    //     BsyUtils.forEach(g.form.items, function (a1, b1) {
    //       if (b1.tab) fieldtabs[b1.widget.widgetName] = b1.tab;
    //     });
    //     let newdata = {};
    //     let fields = [];
    //     let o1 = that._parseFieldLabelFormat(o, g.form.items);
    //     BsyUtils.forEach(o1, function (a1, b1) {
    //       let tmpdata = { ...b1 };

    //       if (["dataload", "button"].indexOf(b1.type) > -1) {
    //         return !0;
    //       }
    //       if (b1.isOrderCol) {
    //         return !0;
    //       }

    //       if (fieldtabs.hasOwnProperty(b1.name)) {
    //         tmpdata.tab = fieldtabs[b1.name];
    //       }
    //       fields.push(tmpdata);
    //       newdata[b1.tag] = g.data[b1.name];
    //       newdata[b1.name] = g.data[b1.name];
    //     });
    //     newdata = { ...newdata, ...g.data };
    //     if (g.hasCoop || !g.hasFlow) {
    //       flow_log = !1;
    //     }
    //     if (flow_log) {
    //       newdata["flowStack"] = g.data["flowStack"];
    //       newdata["flowState"] = g.data["flowState"];
    //       newdata["chargers"] = g.data["chargers"];
    //       newdata["flowVer"] = g.data["flowVer"];
    //     }
    //     if (that.props.ptlist || that.props.readData) {
    //       //外链查询使用
    //       i.dataPerms.ptlist = that.props.ptlist;
    //     }
    //     newdata.optAuth = i.optAuth;

    //     let config = {
    //       ...g.form,
    //       appId: d1.appId,
    //       refAppId: d1.refAppId,
    //       entryId: d1.entryId,
    //       formId: d1.formId,
    //       items: g.form.items,
    //       form: g.form,
    //       entrance: entrance,
    //       fieldShowRules: that.props.ignoreAuth ? [] : g.form.fieldShowRules,
    //       subformFieldShowRules: that.props.ignoreAuth
    //         ? []
    //         : g.form.subformFieldShowRules,
    //       origin: n.origin,
    //       originPrint: n.origin,
    //       authGroupId: n.origin ? undefined : authGroupId,
    //       needFetchViewData:
    //         n.origin === "report" || n.isEtlTable || n.recycle ? !1 : !0,
    //       hasShowFieldsBtn: n.hasShowFieldsBtn || n.needFetchViewData,
    //       widgetId: that.state.widgetId,
    //       hasFlowLog: flow_log,
    //       hasLogView: flow_log,
    //       hasFlowBtn: flow_log,
    //       optAuth: newdata.optAuth,
    //       is_dock_form: g.is_dock_form,
    //       ptlist: i.dataPerms && i.dataPerms.ptlist,
    //       hasShareBtn: !1,
    //       width: "80%",
    //       forms: that.state.forms,
    //       header: fields, //a._parseFieldLabelFormat(o),
    //       allShowFields: fields,
    //       data: newdata,
    //       editValue: newdata,
    //       sourceType: n.type,
    //       multiTabs: g.formTabs,
    //       formTabsStyle: g.formTabsStyle || {},
    //       dataId: g.data._id,
    //       rawdata: that.props.rawdata,
    //       extDashData: that.props.rawdata ? extDashData : null,
    //       title: that.props.title,
    //       height: "100%",
    //       hasSwitchBtn: !0,
    //       dataIndex: e + 1,
    //       hasPrintBtn: !0,
    //       hasCustomPrint: !0,
    //       dataCount: that.AllData.length,
    //       hasEditBtn: hasEditBtn,
    //       hasDeleteBtn: hasDeleteBtn,
    //       hasCopy: hasCopy,
    //       hasLog: hasLog,
    //       dataPerms: i.dataPerms,
    //       hasComment: hasComment,
    //       popupFormPath: a.popupFormPath.concat({
    //         appId: a.props.appId,
    //         entryId: a.props.entryId,
    //         formId: a.props.forms[0],
    //         widgetId: a.props.widgetId,
    //       }),
    //     };
    //     const configEvents = {
    //       onSwitchData: function (t) {
    //         that.doShowData(t - 1, null, null, false, layerRef);
    //       },
    //       onClose: function (isEdit, reshow) {
    //         if (isEdit) {
    //           that.reload({});
    //         }
    //         if (reshow) {
    //           that.doShowData(e, type, data, false, layerRef);
    //           return;
    //         }
    //         restore();
    //         layerRef.close();
    //       },
    //       onCloseFlow: function () { },
    //       onDeleteData: function () {
    //         BsyAlert({
    //           // title: React.language("api.deleteData"),
    //           title: React.language("del.data.tip"),
    //           type: "error",
    //           text4Cancel: React.language("cancel"),
    //           text4Ok: React.language("ok"),
    //           OkType: "red",
    //           ok: function () {
    //             that.BBY_doDeleteData([f]);
    //             restore();
    //             layerRef.close();
    //           },
    //         });
    //       },
    //     };

    //     const formConfig = {
    //       ...g,
    //       appId: a.state.appId,
    //       entryId: a.state.entryId,
    //       formId: a.state.forms[0],
    //       originPrint: n.origin,
    //       dataId: f,
    //       content: config,
    //     };

    //     BsyMaskLayer({
    //       customCls: animation ? "fadein-right" : "",
    //       onContentCreate: (ref) => {
    //         layerRef = ref;

    //         return (
    //           <BsyFormPane
    //             {...config}
    //             {...configEvents}
    //             formConfig={formConfig}
    //             mode={"view"}
    //           />
    //         );
    //       },
    //     });
    //   },
    //   function () {
    //     // t11 && t11.close();
    //     restore();
    //     lowLayer && lowLayer.close();
    //     return !1;
    //   },
    //   function () {
    //     lowLayer && lowLayer.close();
    //     // t11 && t11.close();
    //   }
    // );

  };

  getSubFlowNode = (item, done) => {
    const { subFlowMoreState } = this.state;
    if (BsyUtils.isObjectEmpty(item.subProcesses)) {
      return "";
    }

    return (
      <div className="flow-log-subflow">
        <div className="process">{`${React.language(
          "flow.node.flow_sub.child"
        )}${React.language("state")}（${React.language("done")} ${done?.length
          }/${item.subProcesses?.length}）`}</div>
        <div
          className={`subflow-item-list ${subFlowMoreState[String(item.flowId)] ? "more" : ""
            }`}
        >
          {item.subProcesses?.map((it) => {
            return (
              <div
                className="subflow-item"
                onClick={() => {
                  this.openSubFlow({
                    appId: it.appId,
                    entryId: it.entryId,
                    dataId: it.dataId,
                    groupId: 0,
                  });
                  // console.log(it);
                  // open(DataDetailPopup, {
                  //   appId: it.appId,
                  //   entryId: it.entryId,
                  //   dataId: it.dataId,
                  //   groupId: 0,
                  // });
                }}
              >
                <BsyUserAvatarThumbList
                  mode="avatar"
                  list={[
                    {
                      status: 1,
                      avatarurl: it.creator.avatar,
                      nickname: it.creator.nickname,
                    },
                  ]}
                />
                <div className={it.state}>
                  {it.state === "complete"
                    ? React.language("done")
                    : React.language("flow.state.inProcess")}
                </div>
              </div>
            );
          })}
        </div>
        {(item.subProcesses?.length || 0) > 3 && (
          <div
            className="subflow-item-more"
            onClick={() => {
              this.setState({
                subFlowMoreState: {
                  ...subFlowMoreState,
                  [String(item.flowId)]: !subFlowMoreState[String(item.flowId)],
                },
              });
            }}
          >
            {subFlowMoreState[String(item.flowId)]
              ? React.language("collect")
              : `${React.language("view")}${React.language("all")}`}
          </div>
        )}
      </div>
    );
  };

  renderItem = (item) => {
    // console.log(item);

    const newTime =
      item.flowType === "todo"
        ? dayjsUtils.timeToTZ(new Date()).getTime()
        : dayjsUtils.timeToTZ(item.updateTime).getTime();
    const startTime = dayjsUtils.timeToTZ(item.createTime).getTime();

    const done = item.subProcesses?.filter((it) => {
      return it.state !== "inProcess";
    });

    const showEndTime =
      item.flowType !== "todo"
        ? item.subProcesses
          ? item.subProcesses?.length === done?.length
          : true
        : false;

    let url = "";
    if (item.signature && item.signature.length > 0) {
      url = BsyUtils.getfiledownloadURL(item.signature[0], {});
    }

    return (
      <div className="flow-log-item ">
        {item.flowType == "todo" ? (
          <div className="title">
            <span className="nodename" style={{ color: "#0265FF" }}>
              <i className="icon-bsy-on-all"></i>
              {item.flowName}
            </span>
            <span className="doing">
              {React.language("mobile.flow.node.doing")}
            </span>
          </div>
        ) : (
          <div className="title">
            <span className="nodename">
              <i className="icon-newsuccess1"></i>
              {item.flowName}
            </span>
          </div>
        )}

        <div className="item-content">
          <div className="info">
            {BsyUtils.isObjectEmpty(item.subProcesses) ? (
              <>
                <div className="op-info">
                  {item.flowType == "todo" ? (
                    <FlowLogShowCharge {...item} />
                  ) : (
                    <>
                      <BsyUserAvatarThumbList
                        mode="avatar"
                        list={[
                          { avatarurl: item.avatar, nickname: item.operator },
                        ]}
                      />
                      <div className="op">
                        <span
                          style={{
                            color:
                              item.flowAction.indexOf("fail") > -1
                                ? "#ee5555"
                                : "",
                          }}
                        >
                          {item.flowActionName}
                        </span>
                      </div>
                    </>
                  )}
                </div>
                <div className="split"></div>
              </>
            ) : (
              ""
            )}

            {this.getSubFlowNode(item, done)}

            {item.flowAction.indexOf("fail") > -1 ? (
              <div className="row" style={{ color: "#ee5555" }}>
                {this.getCode2Str(item.err_code)}
              </div>
            ) : (
              ""
            )}
            {item.comment && (
              <div className="row">{`${React.language("form.comment")}：${item.comment
                }`}</div>
            )}
            {item.signature && (
              <div className="row">
                <span>{`${React.language("widget.signature")}： `}</span>
                {url && <img src={url} alt=""></img>}
              </div>
            )}

            <div className="row">
              {React.language("flow.log.startTime", {
                time: BsyUtils.date2Str(
                  dayjsUtils.timeToTZ(item.createTime),
                  "yyyy-MM-dd HH:mm:ss"
                ),
              })}
            </div>
            {showEndTime ? (
              <div className="row">
                {React.language("etl.log.endTime", {
                  time: BsyUtils.date2Str(
                    dayjsUtils.timeToTZ(item.updateTime),
                    "yyyy-MM-dd HH:mm:ss"
                  ),
                })}
              </div>
            ) : (
              ""
            )}
            {showEndTime && newTime !== startTime ? (
              <div className={"row op-time "}>
                {React.language("flow.dealwith.time") +
                  BsyUtils.convertToRemainingTime(Math.floor((newTime - startTime) / 1000))}
              </div>
            ) : item.flowType === "todo" ? (
              <div className={"row op-time ing"}>
                {React.language("flow.wait.time") +
                  BsyUtils.convertToRemainingTime(
                    Math.floor((dayjsUtils.timeToTZ(new Date() ).getTime() - startTime) / 1000)
                  )}
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    );
  };

  renderSubFlowItem = () => {
    return <div className="flow-log-item-sub-flow "></div>;
  };

  componentDidMount() {
    // {"appId":"58db7e708984d6408b2e8c70","entryId":"5e97017d610f44f96af2b912","formId":"5e97017d610f44f96af2b912","dataId":"5463ea469d90fe0de43fa488","authGroupId":null,"popupFormPath":[]}
    let {
      appId,
      entryId,
      formId,
      authGroupId,
      popupFormPath,
      data,
      flowType,
      flowId,
      extDashData,
      refAppId
    } = this.state;

 
    React.axios("/data/log_flow", {
      appId,
      entryId,
      formId,
      authGroupId,
      flowType: flowType,
      flowId: flowId,
      dataId: data._id,
      extDashData,
      popupFormPath,
      refAppId: refAppId,
    }).then((res) => {
      BsyUtils.showAjaxTip(res.data, () => {
        let subFlowMoreState = {};

        if (BsyUtils.isObjectEmpty(res.data.logs)) {
          return;
        }

        const list = res.data.logs.map((it) => {
          subFlowMoreState[String(it.flowId)] = false;
          // setSubFlowState({ ...subFlowMoreState, [String(it.flowId)]: false });
          return {
            ...it,
            charges: [
              {
                status: 1,
                avatarurl: it.avatar,
                nickname: it.operator,
              },
            ],
            flowType: "",
          };
        });

        const _todolist = (data?.chargers || []).map((it) => {
          const subflowNodes = list.filter((listit) => {
            return (
              listit.flowId === it.flowId &&
              !BsyUtils.isObjectEmpty(listit.subProcesses)
            );
          });
          const charges =
            subflowNodes.length === 0
              ? [
                {
                  status: 1,
                  avatarurl: it.avatar,
                  nickname: it.userNickname,
                },
              ]
              : subflowNodes[0].subProcesses.map((subit) => {
                return {
                  status: 1,
                  avatarurl: subit.creator.avatar,
                  nickname: subit.creator.nickname,
                };
              });
          return {
            _id: "",
            charges,
            createTime: res.data.times[it.flowId],
            flowAction: "",
            err_code: "",
            flowName: it.flowName,
            flowId: it.flowId,
            operator: it.userNickname,
            avatar: it.avatar,
            updateTime: "",
            flowTarget: "",
            flowType: "todo",
            flowActionName: React.language("mobile.flow.node.doing"),
          };
        });
        const _list = [..._todolist, ...list];
        const newTime =
          BsyUtils.isNumber(data?.flowState) && Number(data.flowState) === 0
            ? dayjsUtils.timeToTZ(new Date()).getTime()
            : dayjsUtils.timeToTZ(list[0].updateTime).getTime();
        const startTime = dayjsUtils.timeToTZ(list[list.length - 1].createTime).getTime();
        this.setState({
          loglist: _list,
          subFlowMoreState,
          allTimeLong: BsyUtils.convertToRemainingTime(
            Math.floor((newTime - startTime) / 1000)
          ),
        });
      });
    });
  }

  render() {
    const { baseCls, customCls } = this.options;
    const { loglist } = this.state;
    return (
      <div className={classNames(baseCls, customCls)}>
        {this.renderAllTime()}
        {loglist.map((item) => {
          return this.renderItem(item);
        })}
      </div>
    );
  }
}
